<template>
    <div class="indicator" :class="{ 'show': show }" :style="{ backgroundColor: backgroundColor }">
        {{ value }}
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Number],
            required: true,
        },
        backgroundColor: {
            type: String,
            default: '#41ABC4',
        },
    },
};
</script>

<style scoped>
.indicator.show {
    display: inline-block;
}

.indicator {
    position: relative;
    display: block;
    line-height: 0;
    transform: translateY(-10px);
    margin-right: -4px;
    min-width: 16px;
    height: 16px;
    border-radius: 8px;
    border-bottom-left-radius: 0;
    line-height: 16px;
    font-size: 12px;
    color: white;
    display: none;
    background-color: #41ABC4;
    text-align: center;
}
</style>